import React, { useEffect, useState } from "react";
import s from "./TwilloModalContent.module.scss";
import SearchInput from "../../../../../../../../global components/Forms/SearchInput/SearchInput";
import { Empty, Select, TableColumnsType } from "antd";
import ReusableTable from "../../../../../../../../global components/Table/Table";
import ReusableDrawer from "../../../../../../../../global components/Drawer/ReuseableDrawer";
import useSWR from "swr";
import {
  parseClientError,
  swrFetcher,
} from "../../../../../../../../libs/api/Endpoints";
import { UseAuthToken } from "../../../../../../../../libs/api/userSession";
import {
  GetCountriesType,
  GetTwilloNumbers,
} from "../../../../../../../../libs/Utils/Types/NumberManagement";
import Unauthorised from "../../../../../../../../global components/Unauthorised";
import { AssignNumber as ApproveRequest } from "../../local components/AssignNumber";
type ColumnType = {
  number: string;
  serialNumber: number;
  key: string;
  locality: string;
  region: string;

  actions: string;
  country: string;
};
type PropType = {
  closeModal: () => void;
  assignId?: string;
  mutate: () => void;
  areaCode: string;
  country: string;
};
function TwilloModalContent({
  closeModal,
  mutate,
  assignId,
  areaCode,
  country,
}: PropType) {
  const token = UseAuthToken();
  const [twilloSearch, setTwilloSearch] = useState<string>("");
  const [number, setNumber] = useState<string>("");
  const [unauthorized, setUnauthorized] = useState<
    boolean | { title: string; message: string }
  >(false);
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);
  const [code, setCode] = useState<string>("US");
  const [type, setType] = useState<string>("local");
  const { data: countries, isLoading: fetchingCountries } = useSWR<
    { data: GetCountriesType },
    any,
    any
  >(
    token ? ["api/admin/number-requests/supported-countries", token] : null,
    swrFetcher,
  );

  const { data, isLoading, error } = useSWR<
    { data: GetTwilloNumbers },
    any,
    any
  >(
    token
      ? [
          "api/admin/phone-numbers/search",
          token,
          {
            ...(type && { type }),
            ...(code && { country: code }),
            ...(twilloSearch && { phoneNumber: twilloSearch }),
            ...(areaCode && { code: areaCode }),
          },
        ]
      : null,
    swrFetcher,
  );
  const columns: TableColumnsType<ColumnType> = [
    {
      title: "S/N",
      key: "serialNumber",
      dataIndex: "serialNumber",
      render: (serialNumber: string) => <span>{serialNumber}</span>,
    },
    {
      title: "Number",
      key: "number",
      dataIndex: "number",
      render: (number: string) => <span>{number}</span>,
    },
    {
      title: "Country",
      key: "country",
      dataIndex: "country",
      render: (country: string) => <span>{country}</span>,
    },
    {
      title: "Locality",
      key: "locality",
      dataIndex: "locality",
      render: (locality: string) => <span>{locality}</span>,
    },
    {
      title: "Region",
      key: "region",
      dataIndex: "region",
      render: (region: string) => <span>{region}</span>,
    },

    {
      title: "Actions",
      key: "actions",
      dataIndex: "actions",
      render: (actions: string, record: { number: string }) => (
        <button
          className={s.assignBtn}
          onClick={() => {
            closeModal();
            setTimeout(() => {
              setNumber(record.number);
              setOpenDrawer(true);
            }, 300);
          }}
        >
          Assign
        </button>
      ),
    },
  ];

  const handleSearch = (value: string) => {
    setTwilloSearch(value);
  };

  const handleDrawer = () => {
    setOpenDrawer((prev) => !prev);
  };

  const dataSource: ColumnType[] =
    data?.data.map((item, index) => ({
      actions: "",
      locality: item.locality || "N/A",
      region: item.region || "N/A",
      country: item.country,
      number: item.phoneNumber,
      key: item.friendlyName,
      serialNumber: index + 1,
    })) ?? [];

  useEffect(() => {
    if (error) {
      const e = parseClientError(error);
      if (e.statusCode === 403) {
        setUnauthorized(true);
      } else {
        setUnauthorized({
          title: "Error!",
          message: e.message || "Something went wrong",
        });
      }
    } else {
      setUnauthorized(false);
    }
  }, [error]);
  return (
    <>
      <div className={s.wrapper}>
        <div className={s.searchInput}>
          <SearchInput
            style={{ width: "100%", height: "100%" }}
            placeholder="Search Twilio for available numbers"
            width={332}
            height={45}
            handleSearch={handleSearch}
            className={s.input}
          />
        </div>
        <div className={s.filters}>
          <Select
            placeholder="Country"
            disabled={!!country?.length}
            defaultValue={country ?? undefined}
            options={countries?.data.map((item) => ({
              value: item.code,
              label: item.name,
            }))}
            className={s.dropDownn}
            showSearch
            loading={fetchingCountries}
            notFoundContent={!fetchingCountries && "No countries found"}
            onChange={(value) => setCode(value)}
          />
          {/* <Select
            placeholder="Area code"
            options={[{ value: "sample", label: <span>sample</span> }]}
            className={s.dropDownn}
          />
          <Select
            placeholder="Carrier"
            options={[{ value: "sample", label: <span>sample</span> }]}
            className={s.dropDownn}
          /> */}
          <Select
            placeholder="Type"
            options={[
              { value: "local", label: "Local" },
              { value: "tollfree", label: "Toll-free" },
              { value: "mobile", label: "Mobile" },
            ]}
            className={s.dropDownn}
            onChange={(value) => setType(value)}
            defaultValue={type}
          />
        </div>
        {
          // <div className={s.empty}>
          //   <div className={s.iconWrapper}>
          //     <SearchSolidIcon className={s.icon} />
          //   </div>
          //   <p className={s.helperText}>
          //     Search available numbers and assign to a user based on their
          //     preference.{" "}
          //   </p>
          // </div>
          <div className={s.table}>
            <ReusableTable
              sticky={{ offsetHeader: 0 }}
              scroll={{ y: 270, x: "max-content" }}
              columns={columns}
              dataSource={dataSource}
              loading={isLoading}
              noDataComponent={
                unauthorized ? (
                  typeof unauthorized === "boolean" ? (
                    <Unauthorised />
                  ) : (
                    <Unauthorised error={unauthorized} />
                  )
                ) : (
                  <Empty />
                )
              }
            />
          </div>
        }
      </div>
      <ReusableDrawer
        Open={openDrawer}
        handleOpen={handleDrawer}
        title="Assign number"
        classNames={{
          body: s.drawerbody,
        }}
      >
        <ApproveRequest
          number={number}
          mutate={mutate}
          closeDrawer={handleDrawer}
          id={assignId}
        />
      </ReusableDrawer>
    </>
  );
}

export default TwilloModalContent;
